<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GchWv/tc-custom/9781439677759.jpg?1705539782324" alt="This image is the cover for the book History Lover's Guide to Cincinnati, A, History & Guide"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">History Lover's Guide to Cincinnati, A, History & Guide
      </h1>
      <p class="bookDescription body article font2">
        <p>A tour of the Queen City's rich heritage One of the oldest cities in the Midwest, Cincinnati has history in its bones. In the 1800s, the city was often styled the "Paris of America" due in part to ambitious architectural projects like the Music Hall, Cincinnatian Hotel, and city hall. Many of these historical structures still exist. The city also has sundry links to American presidents, whose stories can still be seen if you know where to look. Thriving destinations like Over the Rhine and Findlay Market provide glimpses of Cincinnati as it once was and how it is today. Offering something for native and visitor alike, author Robert Schrage leads a trip through the past and present of one of the nation's most historic cities.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robert Schrage
      </h2>
      
      <p class="authorDescription body article">Robert Schrage is active in local history circles. He has served on numerous local historical boards and is a frequent speaker on local and regional history. In 2015, Schrage received the William Conrad Preservation Excellence Award for Lifetime Achievement in preservation of local history. His previous works include The Hidden History of Kentucky Political Scandals, Lost Northern Kentucky, Legendary Locals of Covington, Eyewitness to History: A Personal Journal (winner of honorable mentions at the New York, Amsterdam and Florida Book Festivals) and more.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8b33e04a